import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import styles from './LoginScreen.module.css';
import Button from './../../components/button/Button';
import Input from './../../components/input/Input';
import ReactSVG from 'react-svg';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import {removeAccents} from './../../utils/Utils';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AuthResources from './../../resourcers/authResources';
import CoutryResources from './../../resourcers/countryResources';

import River from './../../assets/img/river.png';
import River1 from './../../assets/img/river2.png';
import River2 from './../../assets/img/river3.png';
import River3 from './../../assets/img/river4.png';
import River4 from './../../assets/img/river5.png';
import BackArrow from './../../assets/img/arrow_back.svg';
import BackButton from './../../assets/img/back-icon.svg';
import CloseIcon from './../../assets/img/close-icon.svg';
import LoadingScreen from 'react-loading-screen';


class LoginScreen extends Component {

    steps = 4;

    authResources = new AuthResources();
    coutryResources = new CoutryResources();

    constructor(props) {
        super(props);
        this.intl = this.props.intl;
        this.backgroundAdded = false;
        this.countryPlaceholder = this.intl.formatMessage({id: "countryPlaceholder"});
        this.statePlaceholder = this.intl.formatMessage({id: "statePlaceholder"});
        this.inputRef = React.createRef();

        this.state = {
            inputFullscreen: "hidden",
            inputType: "country",
            inputValue: "",
            stepText: "",
            step: 0,
            countries: [],
            states: [],
            userCountry: "",
            userState: "",
            userAge: "",
            userGender: "",
            animate: false,
            animateEnd: false,
            animation: ""
        }

        this.optionListDidMount = this.optionListDidMount.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.previousStep = this.previousStep.bind(this);
        this.login = this.login.bind(this);
        this.setUserCountry = this.setUserCountry.bind(this);
        this.setUserState = this.setUserState.bind(this);
        this.setUserAge = this.setUserAge.bind(this);
        this.setUserGender = this.setUserGender.bind(this);
        this.setInputValue = this.setInputValue.bind(this);
        this.openTermsConditions = this.openTermsConditions.bind(this);
        this.openInputFullscreen = this.openInputFullscreen.bind(this);
        this.closeInputFullscreen = this.closeInputFullscreen.bind(this);
        this.animationEnd = this.animationEnd.bind(this);

        this.checkIfLogged();
    }

    componentDidMount(){
        let ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') != -1) {
            if(ua.indexOf('chrome') >= -1){
                document.onclick = function(){
                    if(this.state.inputFullscreen === "open"){
                        this.inputRef.current.focus();
                    }
                }.bind(this);
            }
        }
    }

    optionListDidMount(node) {
        if(node){
            node.addEventListener('scroll', function(){
                this.inputRef.current.blur();
            }.bind(this));
        }
    }

    animationEnd() {
        this.setState({
            animateEnd: true
        });
    }

    checkIfLogged() {
        if(this.authResources.getCurrentUser()){
            this.props.history.push('/home');
        }
    }

    login() {
        let country;
        for(let i=0; i<this.props.countries.length; i++){
            if(this.props.countries[i].name === this.state.userCountry){
                country = this.props.countries[i];
                break;
            }
        };
        let user = {
            country: country["_id"],
            state: this.state.userState,
            gender: this.state.userGender,
            age: this.state.userAge
        }
        this.authResources.login(user).then(response => {
            this.authResources.setCurrentUser(response);
            this.props.history.push({
                pathname: "/home",
                state: {
                    animation: "fadeIn"
                }
            });
        });
    }

    previousStep() {
        let stepText = this.intl.formatMessage({id: "next"});

        this.setState({
            step: this.state.step - 1,
            stepText: stepText,
            animate: true,
            animateEnd: false,
            animation: "slideInLeft",
            inputFullscreen: "hidden"
        });
    }

    nextStep() {
        let stepText = "";
        let nextStep = this.state.step + 1;

        switch(nextStep){
            case 4:
                stepText = this.intl.formatMessage({id: "enter"});
                break;
            default:
                stepText = this.intl.formatMessage({id: "next"});
                break;
            }

        this.setState({
            step: nextStep,
            stepText: stepText,
            animate: true,
            animateEnd: false,
            animation: "slideInRight"
        });
        if(this.state.step >= this.steps) {
            this.login();
        }
    }

    openTermsConditions(){
        this.props.history.push("/termsConditions");
    }

    openInputFullscreen(type){
        this.setState({
            inputType: type,
            inputFullscreen: "open",
            inputValue: ""
        });

        setTimeout(function(){
            this.inputRef.current.focus();
        }.bind(this), 300);
    }

    closeInputFullscreen(option){
        let states = [];
        let inputValue = this.state.inputValue;

        if(option.name) {
            inputValue = option.name;
            if(this.state.inputType === "country" && option.states.length > 0) {
                option.states.map((state, i) => {
                    states.push({name: state, _id: i});
                });
                this.setState({
                    inputType: "state",
                    inputValue: "",
                    userCountry: inputValue,
                    userState: "",
                    states: states
                });
                this.inputRef.current.focus();
                return;
            }

            if(this.state.inputType === "country"){
                this.setState({
                    states: states,
                    inputFullscreen: "close",
                    userCountry: inputValue
                })
            }

            if(this.state.inputType === "state"){
                this.setState({
                    inputFullscreen: "close",
                    userState: inputValue
                })
            }
        }else{
            let options, optionsFiltered;
            if(this.state.inputType === "country") {
                options = this.props.countries;
                optionsFiltered = options.filter(option => option.name.toLowerCase().startsWith(this.state.inputValue.toLowerCase()));
                if(optionsFiltered.length === 0){
                    this.setState({
                        states: states,
                        inputFullscreen: "close",
                        userCountry: "",
                        userState: ""
                    })
                    return;
                }
            }
            if(this.state.inputType === "state") {
                options = this.state.states;
                optionsFiltered = options.filter(option => option.name.toLowerCase().startsWith(this.state.inputValue.toLowerCase()));
                if(optionsFiltered.length === 0){
                    this.setState({
                        inputFullscreen: "close",
                        userState: ""
                    })
                    return;
                }
            }
        }

        this.setState({
            inputFullscreen: "close"
        })
    }

    setUserCountry(e) {
        this.setState({
            userCountry: e.target.value,
            userState: ""
        });
    }

    setUserState(e) {
        this.setState({
            userState: e.target.value
        })
    }

    setUserAge(e) {
        this.setState({
            userAge: e.target.value
        });
    }

    setUserGender(e) {
        this.setState({
            userGender: e.target.value
        });
    }

    setInputValue(e) {
        this.setState({
            inputValue: e.target.value
        });
    }

    renderFullscreenInput() {
        if(this.state.step === 1)
        {
            let animation, placeholder, options;

            if(this.state.inputFullscreen === "hidden"){
                animation = styles.fullscreenHidden;
            }
            if(this.state.inputFullscreen === "open"){
                animation = "animated slideInUp";
            }
            if(this.state.inputFullscreen === "close"){
                animation = "animated slideOutDown";
            }

            if(this.state.inputType === "country") {
                placeholder = this.countryPlaceholder;
                options = this.props.countries;
            }
            if(this.state.inputType === "state") {
                placeholder = this.statePlaceholder;
                options = this.state.states;
            }

            let searchValue = removeAccents(this.state.inputValue.toLowerCase().trim());

            let optionList;
            let optionsFiltered = options.filter(option => removeAccents(option.name.toLowerCase()).startsWith(searchValue));

            if(optionsFiltered.length > 0){
                optionList = (
                    <div ref={this.optionListDidMount} id="inputOptions" className={styles.inputOptions}>
                        {options
                            .filter(option => option.name.toLowerCase().startsWith(this.state.inputValue.toLowerCase()))
                            .map(option => {
                                let boldLabel, label = "";
                                if(this.state.inputValue === "") {
                                    label = option['name'];
                                }
                                else
                                {
                                    boldLabel = this.state.inputValue.charAt(0).toUpperCase() + this.state.inputValue.slice(1);
                                    label = option['name'].toLowerCase().replace(this.state.inputValue.toLowerCase(), "");
                                }

                                return (
                                    <p key={option._id} onClick={() => this.closeInputFullscreen(option)}>
                                        <span className={styles.optionBold}>
                                            <b>{boldLabel}</b>
                                        </span>
                                        <span className={styles.option}>
                                            {label}
                                        </span>
                                    </p>
                                );
                        })}
                    </div>
                );
            } else {
                optionList = (
                    <div className={styles.inputOptions}>
                        <p>
                            <span className={styles.option}>
                                <FormattedMessage id="searchNotFound1" /> <FormattedMessage id="searchNotFound2" />
                            </span>
                        </p>
                    </div>
                );
            }

            return (
                <div className={[styles.fullscreen, animation].join(' ')}>
                    <div className={styles.inputTop}>
                        <ReactSVG src={CloseIcon} onClick={this.closeInputFullscreen} className={styles.closeButton}/>
                        <Input inputRef={this.inputRef} onChange={this.setInputValue} value={this.state.inputValue} placeholder={placeholder} />
                    </div>
                    {optionList}
                </div>
            );
        }
    }

    renderTitleSection() {
        let back, backButtonWhite, className = "";
        if(this.state.step > 1 && this.state.inputFullscreen !== "open"){
            if(this.state.step === this.steps){
                backButtonWhite = styles.backButtonWhite;
            }
            back = (
                <ReactSVG src={BackButton} onClick={this.previousStep} className={[styles.backButton, backButtonWhite].join(' ')}/>
            );
        }
        if(this.state.step <= 1){
            className = styles.titlePadding;
        }
        return (
            <div className={[styles.titleSection, className].join(' ')}>
                {back}
            </div>
        );
    }

    renderQuestionSection() {

        let title, subtitle;
        let className = styles.questionSection;

        switch(this.state.step)
        {
            case 0:
                title = 'welcome';
                subtitle = 'welcomeText';
                break;

            case 1:
                title = 'question1';
                subtitle = '';
                break;

            case 2:
                title = 'question2';
                subtitle = '';
                break;

            case 3:
                title = 'question3'
                subtitle = '';
                break;

            case 4:
                title = 'ready';
                subtitle = 'finishIntro';
                break;

            default:
                break;
        }

        if(subtitle != "") {
            subtitle = (<FormattedMessage id={subtitle} />);
        } else {
            subtitle = null;
        }

        return (
            <div className={className}>
                <div className={styles.mainText}>
                    <h1><FormattedMessage id={title}/></h1>
                </div>
                <div className={styles.subText}>
                    <h4>{subtitle}</h4>
                </div>
            </div>
        );
    }

    renderSelect() {
        let states;
        if(this.state.userCountry !== "" && this.state.states.length > 0){
            states = (
                <div onClick={() => this.openInputFullscreen("state")}>
                    <Input value={this.state.userState} endAdornment={(<ReactSVG src={BackArrow} className={styles.inputArrow} />)} placeholder={this.statePlaceholder} />
                </div>
            );
        }

        if(this.state.inputFullscreen !== "open"){
            return (
                <div className={styles.inputContainer}>
                    <div onClick={() => this.openInputFullscreen("country")}>
                        <Input value={this.state.userCountry} endAdornment={(<ReactSVG src={BackArrow} className={styles.inputArrow} />)} placeholder={this.countryPlaceholder}/>

                    </div>
                    {states}
                </div>
            );
        }
    }

    renderAgeOptions() {
        let age1 = this.intl.formatMessage({id: "age1"});
        let age2 = this.intl.formatMessage({id: "age2"});
        let age3 = this.intl.formatMessage({id: "age3"});
        let age4 = this.intl.formatMessage({id: "age4"});
        let age5 = this.intl.formatMessage({id: "age5"});

        return (
            <RadioGroup
                value={this.state.userAge}
                onChange={this.setUserAge}
                >
                <FormControlLabel
                    classes={{label: styles.formControlLabel}}
                    value={"1"}
                    control={<Radio classes={{root: styles.radio, checked: styles.radioChecked}} />}
                    label={age1}
                />
                <FormControlLabel
                    classes={{label: styles.formControlLabel}}
                    value={"2"}
                    control={<Radio classes={{root: styles.radio, checked: styles.radioChecked}} />}
                    label={age2}
                />
                <FormControlLabel
                    classes={{label: styles.formControlLabel}}
                    value={"3"}
                    control={<Radio classes={{root: styles.radio, checked: styles.radioChecked}} />}
                    label={age3}
                />
                <FormControlLabel
                    classes={{label: styles.formControlLabel}}
                    value={"4"}
                    control={<Radio classes={{root: styles.radio, checked: styles.radioChecked}} />}
                    label={age4}
                />
                <FormControlLabel
                    classes={{label: styles.formControlLabel}}
                    value={"5"}
                    control={<Radio classes={{root: styles.radio, checked: styles.radioChecked}} />}
                    label={age5}
                />
            </RadioGroup>
        );
    }

    renderGenderOptions() {
        let gender1 = this.intl.formatMessage({id: "gender1"});
        let gender2 = this.intl.formatMessage({id: "gender2"});
        let gender3 = this.intl.formatMessage({id: "gender3"});

        return (
            <RadioGroup
                value={this.state.userGender}
                onChange={this.setUserGender}
                >
                <FormControlLabel
                    classes={{label: styles.formControlLabel}}
                    value={"1"}
                    control={<Radio classes={{root: styles.radio, checked: styles.radioChecked}} />}
                    label={gender1}
                />
                <FormControlLabel
                    classes={{label: styles.formControlLabel}}
                    value={"2"}
                    control={<Radio classes={{root: styles.radio, checked: styles.radioChecked}} />}
                    label={gender2}
                />
                <FormControlLabel
                    classes={{label: styles.formControlLabel}}
                    value={"3"}
                    control={<Radio classes={{root: styles.radio, checked: styles.radioChecked}} />}
                    label={gender3}
                />
            </RadioGroup>
        );
    }

    renderImage() {
        return (
            <div className={styles.imageSection}>
                <h1></h1>
            </div>
        );
    }

    renderAnswerSection() {

        let section;

        switch(this.state.step) {
            case 1:
                section = this.renderSelect();
                break;
            case 2:
                section = this.renderAgeOptions();
                break;
            case 3:
                section = this.renderGenderOptions();
                break;
            case 4:
                section = this.renderImage();
                break;
            default:
                break;
        }
        return (
            <div className={styles.answerSection}>
                {section}
            </div>
        );
    }

    renderActionSection() {

        switch(this.state.step){
            case 0:
                return (
                    <div className={styles.enterActionSection}>
                        <Button onClick={this.nextStep} className={styles.enterButton} styleType="reverse">
                            <FormattedMessage id="continue" />
                        </Button>
                        <div className={styles.termsSection}>
                            <small><FormattedMessage id="agreement" /></small>
                            <br/>
                            <small onClick={this.openTermsConditions}>
                                <b><FormattedMessage id="termsAndConditions" /></b>
                            </small>
                        </div>
                    </div>
                );

            case 1:
                if(this.state.inputFullscreen !== "open" && this.state.userCountry !== ""){
                    return (
                        <div className={styles.countryButtonContainer}>
                            <Button disabled={this.state.userCountry === ""} onClick={this.nextStep} styleType="light" className={styles.nextButton}>
                                {this.state.stepText}
                            </Button>
                        </div>
                    );
                }
                break;

            default:
                let disabled = false, styleType = "light", jumpHidden = "";
                if(this.state.step === this.steps){
                    styleType = "reverse";
                    jumpHidden = styles.hidden;
                }
                if(this.state.step === 2 && this.state.userAge === ""){
                    disabled = true;
                }
                if(this.state.step === 3 && this.state.userGender === ""){
                    disabled = true;
                }
                return (
                    <div>
                        <div className={styles.jumpButton}>
                            <a className={jumpHidden} href="JavaScript:Void(0)" onClick={this.nextStep}>
                                <h4><FormattedMessage id="jump" /></h4>
                            </a>
                        </div>
                        <div className={styles.nextActionSection}>
                            <Button disabled={disabled} onClick={this.nextStep} styleType={styleType} className={styles.nextButtonWithJump}>
                                <FormattedMessage id={this.state.stepText} />
                            </Button>
                        </div>
                    </div>
                );
        }
    }

    renderBackgroundImage() {
        let image, hide;
        switch (this.state.step){
            case 0:
                hide = styles.hide;
                image = <img src={River} className={[styles.backgroundImage, styles.backgroundImage1].join(' ')} />
                break;
            case 1:
                hide = styles.hide;
                image = <img src={River1} className={[styles.backgroundImage, styles.backgroundImage2].join(' ')} />
                break;
            case 2:
                hide = styles.hide;
                image = <img src={River2} className={[styles.backgroundImage, styles.backgroundImage3].join(' ')} />
                break;
            case 3:
                hide = styles.hide;
                image = <img src={River3} className={[styles.backgroundImage, styles.backgroundImage4].join(' ')} />
                break;
            case 4:
                hide = styles.hide;
                image = <img src={River4} className={[styles.backgroundImage, styles.backgroundImage5].join(' ')} />
                break;
        }
        return (
            <div className={[styles.backgroundContainer, hide].join(' ')}>
                {image}
            </div>
        );
    }

    render(){
        if(this.props.loaded && !this.backgroundAdded){
            document.body.classList.add("purpleBackground");
            this.backgroundAdded = true;
        }

        if(this.state.step <= this.steps){
            let animation, background = "";
            if(!this.state.animateEnd){
                if(this.props.location.state && this.props.location.state.animateBack && this.state.step === 0){
                    animation = "";
                } else {
                    animation = this.state.animation;
                }
                setTimeout(function(){
                    this.setState({
                        animate: false
                    });
                }.bind(this), 50);
            }
            if(this.props.loaded && (this.state.step === 0 || this.state.step === this.steps)){
                background = styles.purpleBackground;
                document.body.classList.add("purpleBackground");
            } else {
                document.body.classList.remove("purpleBackground");
            }
            let screen;
            if(!this.state.animate){
                screen = (
                    <div className={["page", background, styles.content].join(' ')}>
                        {this.renderActionSection()}
                        {this.renderFullscreenInput()}
                        {this.renderTitleSection()}
                        <div className={animation} onAnimationEnd={this.animationEnd}>
                            {this.renderQuestionSection()}
                            {this.renderAnswerSection()}
                        </div>
                    </div>
                );
            }
            return (
                <div>
                    {this.renderBackgroundImage()}
                    {screen}
                </div>
            );
        }
        else
        {
            return (
                <LoadingScreen
                    loading={true}
                    bgColor="#6428e5"
                    spinnerColor="#f5f5f5"
                ></LoadingScreen>
            );
        }
    }

}

export default injectIntl(LoginScreen);